"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddIconAndLabel = void 0;
var react_1 = __importDefault(require("react"));
var Box_1 = require("./Box");
var core_1 = require("./core");
var HStack_1 = require("./HStack");
var typography_1 = require("./typography");
function AddIconAndLabel(_a) {
    var onClick = _a.onClick, label = _a.label, showText = _a.showText;
    var showLabel = showText && label !== undefined;
    return (react_1.default.createElement(Box_1.Box.Button, { background: showLabel ? '$grey2' : undefined, borderRadius: '$circle', onClick: onClick, width: '$fitContent' },
        react_1.default.createElement(HStack_1.HStack, { space: '$4px' },
            PlusIcon,
            showLabel && (react_1.default.createElement(Box_1.Box, { center: 'vert', spaceRight: '$8px' },
                react_1.default.createElement(typography_1.Text, { size: '$10px', weight: 'medium' }, label))))));
}
exports.AddIconAndLabel = AddIconAndLabel;
var PlusIcon = (react_1.default.createElement("svg", { fill: 'none', height: '16', width: '16', xmlns: 'http://www.w3.org/2000/svg' },
    react_1.default.createElement("rect", { fill: core_1.tokens.colors.$focus, height: '1rem', opacity: 0.1, rx: '8', width: '1rem' }),
    react_1.default.createElement("path", { d: 'M8 5V11', stroke: core_1.tokens.colors.$focus, strokeLinecap: 'round' }),
    react_1.default.createElement("path", { d: 'M5 8H11', stroke: core_1.tokens.colors.$focus, strokeLinecap: 'round' })));
